import React, { useCallback, useRef } from 'react'
import { useMemo } from 'react'
import { sediColumns } from './columns/_columns'
import { Sedi } from '../core/_models'
import GenericTable, {
  GenericTableHandle
} from '../../../../components/GenericTable'
import { useAuth } from '../../../../context/Auth'
import {
  PaginatedResponse,
  PaginationMeta
} from '../../../../interfaces/PaginatedResponse'
import { list } from '../../../../lib/fetch/agencies'

interface SediTableProps {}

const SediTable = ({}: SediTableProps) => {
  const ref = useRef<GenericTableHandle>(null)
  const refetch = useCallback(() => {
    ref.current?.refetch()
  }, [ref])
  const columns = useMemo(() => sediColumns(refetch), [refetch])
  const [{ token }] = useAuth()
  const fetch = useCallback(
    async (
      paginationMeta: PaginationMeta
    ): Promise<PaginatedResponse<Sedi> | string> => {
      let result
      try {
        result = await list({
          token,
          page: paginationMeta.currentPage,
          limit: paginationMeta.itemsPerPage
        })
      } catch (error) {
        let message = 'Error'
        if (error instanceof Error) {
          message = error.message
        }
        result = message
      }
      return result
    },
    [token]
  )
  return <GenericTable columns={columns} onFetch={fetch} ref={ref} />
}

export { SediTable }
